export default __webpack_public_path__ + "static/media/sim-corsica.1468d452.jpg";